import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ISignatureList } from 'src/app/models/communication/safetyreports';

@Component({
    selector: 'medpt-safetyreports-signaturelist',
    templateUrl: './safetyreports-signaturelist.component.html',
    styleUrls: ['./safetyreports-signaturelist.component.scss'],
    standalone: false
})
export class SafetyreportsSignaturelistComponent implements OnInit {
  @Input() eSignatureList!: ISignatureList; 
  @Input() titletxt !: string;
 
  constructor(
    public modal: NgbActiveModal,    
  )  {  }

  ngOnInit(): void {
  }

  

}
